"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignaturePlugin = void 0;
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const user_ui_1 = require("@sierralabs/user-ui");
const SignatureConfigurator = props => {
    var _a, _b, _c;
    const { condition, onChange } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Box, { mt: 2 },
            react_1.default.createElement(core_1.TextField, { fullWidth: true, multiline: true, label: 'Reason', variant: 'outlined', value: ((_a = condition.params) === null || _a === void 0 ? void 0 : _a.reason) || '', onChange: event => {
                    if (condition.params) {
                        condition.params.reason = event.target.value;
                        onChange === null || onChange === void 0 ? void 0 : onChange(Object.assign({}, condition));
                    }
                } })),
        react_1.default.createElement(core_1.Box, { mt: 2 },
            react_1.default.createElement(core_1.TextField, { fullWidth: true, multiline: true, label: 'Meaning', variant: 'outlined', value: ((_b = condition.params) === null || _b === void 0 ? void 0 : _b.meaning) || '', onChange: event => {
                    if (condition.params) {
                        condition.params.meaning = event.target.value;
                        onChange === null || onChange === void 0 ? void 0 : onChange(Object.assign({}, condition));
                    }
                } })),
        react_1.default.createElement(core_1.Box, { mt: 2 },
            react_1.default.createElement(core_1.TextField, { fullWidth: true, multiline: true, variant: 'outlined', label: 'Reason Field Label', helperText: 'Leave empty to hide reason field input.', value: ((_c = condition.params) === null || _c === void 0 ? void 0 : _c.reasonLabel) || '', onChange: event => {
                    if (condition.params) {
                        condition.params.reasonLabel = event.target.value;
                        onChange === null || onChange === void 0 ? void 0 : onChange(Object.assign({}, condition));
                    }
                } }))));
};
const SignatureDisplay = () => {
    return react_1.default.createElement(react_1.default.Fragment, null, "Electronic Signature");
};
exports.SignaturePlugin = {
    type: 'signature',
    label: 'Electronic Signature',
    configurator: SignatureConfigurator,
    display: SignatureDisplay,
    validate: () => true,
    guard: (state, params, render) => {
        console.debug('guards: signature', state, params);
        state.context.reason = params.reasonLabel;
        if (state.isSimulation)
            return true;
        if (!render)
            return false;
        return new Promise(resolve => {
            render(react_1.default.createElement(user_ui_1.ElectronicSignatureDialog, { open: true, meaning: params.meaning, reasonLabel: params.reasonLabel, onCancel: () => {
                    render(undefined);
                    resolve(false);
                }, onSigned: reason => {
                    // add reason to task
                    if (typeof reason !== 'undefined') {
                        state.context.reason = reason;
                    }
                    render(undefined);
                    resolve(true);
                } }));
        });
    }
};
//# sourceMappingURL=SignaturePlugin.js.map